<template>
  <div class="ShipTypeHoldType flex-jc-bt">
    <div class="flex-50 left-side">
      <SpCard custom-class="sp-color-bg-4 card-content">
        <div class="flex-al-center flex-jc-start item">
          <span v-required class="flex-25 label-bold">{{ $l('GrainCapacity') }}</span>
          <SpInput v-model="shipInfo.grainCapacity" required name="grainCapacity" :max="700000" :min="1000" text-type="number" class="flex-15" type="warn" :width="1" />
          <span class="flex-10 unit">{{ $l('CBM') }}</span>

          <span v-required class="flex-20 label-bold">{{ $l('BaleCapacity') }}</span>
          <SpInput v-model="shipInfo.baleCapacity" name="baleCapacity" :max="700000" :min="1000" text-type="number" required class="flex-15" type="warn" :width="1" />
          <span class="flex-10 unit">{{ $l('CBM') }}</span>
        </div>
        <div class="outer-gap">
          <div class="flex-al-center flex-jc-start item">
            <span class="flex-25 label">{{ $l('ShipTypeByCargo') }}</span>
            <SpSelect v-model="shipInfo.cargoTypeId" name="cargoTypeId" class="flex-70" type="warn" :width="1">
              <SpSelectOption v-for="item in shipCargoTypeOptions" :key="item.id" :label="item.name" :value="item.id" />
            </SpSelect>
          </div>
          <div class="flex-al-center flex-jc-start item">
            <span class="flex-25 label">{{ $l('ShipTypeByStructure') }}</span>
            <SpSelect v-model="shipInfo.structureTypeId" name="structureTypeId" class="flex-70" type="warn" :width="1">
              <SpSelectOption v-for="(item, key) in shipStructureTypeOptions" :key="item.id" :label="item.name" :value="item.id" />
            </SpSelect>
          </div>
        </div>
        <div class="outer-gap">
          <div class="flex-al-center flex-jc-start item">
            <span class="flex-25 label" />
            <SpSelect v-model="shipInfo.holdCount" name="holdCount" class="flex-15" type="warn" :width="1">
              <SpSelectOption v-for="n in 9" :key="n" :label="n" :value="n" />
            </SpSelect>
            <span class="flex-5 label">{{ $l('Holds') }}</span>
          </div>
          <div class="flex-al-center flex-jc-start item">
            <span class="flex-25 label">{{ $l('Deckersinhold') }}</span>
            <SpSelect v-model="shipInfo.deckTypeId" name="deckTypeId" class="flex-70" type="warn" :width="1">
              <SpSelectOption v-for="(item, key) in shipDeckTypeOptions" :key="item.id" :label="item.name" :value="item.id" />
            </SpSelect>
          </div>
          <div class="flex-al-center flex-jc-start item">
            <span class="flex-25 label">{{ $l('HoldType') }}</span>
            <SpSelect v-model="shipInfo.holdTypeId" name="holdTypeId" class="flex-70" type="warn" :width="1">
              <SpSelectOption v-for="(item, key) in shipHoldTypeOptions" :key="item.id" :label="item.name" :value="item.id" />
            </SpSelect>
          </div>
        </div>
        <div class="outer-gap">
          <div class="flex-al-center flex-jc-start item">
            <span class="flex-25 label" />
            <SpSelect v-model="shipInfo.hatchCount" name="hatchCount" class="flex-15" type="warn" :width="1">
              <SpSelectOption v-for="n in 9" :key="n" :label="n" :value="n" />
            </SpSelect>
            <span class="flex-5 label">{{ $l('Hatches') }}</span>
          </div>
          <div class="flex-al-center flex-jc-start item">
            <span class="flex-25 label">{{ $l('HatchCoverType') }}</span>
            <SpInput v-model="shipInfo.hatchCoverType" :validate-reg="/^((?=.[a-zA-Z])[A-Za-z0-9-.,\/()& ]{3,64})?$/" name="hatchCoverType" class="flex-70" type="warn" :width="1" />
          </div>
          <div class="flex-al-center flex-jc-start item">
            <span class="flex-25 label">{{ $l('TweenCoverType') }}</span>
            <SpInput v-model="shipInfo.tweenCoverType" :validate-reg="/^((?=.[a-zA-Z])[A-Za-z0-9-.,\/()& ]{3,64})?$/" name="tweenCoverType" class="flex-70" type="warn" :width="1" />
          </div>
        </div>
      </SpCard>
      <p class="reminder">{{ $l('Reminder') }}</p>
    </div>
    <div class="flex-48 mg-t-40 right-side sp-color-bg-4">
      <ShipInfoTable v-model="shipInfo" />
      <div class="outer-gap sp-color-11 text-left title">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</div>
      <div class="mg-t-20 sp-color-11 text-left title-tip">{{ $l('PicturesofHoldsHatchrelatedtothisship') }}</div>
      <SpUploadGroup :business-id="shipInfo.id" file-type="ship/hold-hatch/pic" accept="image" />
      <div class="mg-t-20 sp-color-11 text-left title-tip">{{ $l('Shipdesigndrawingsandparametersrelatedtotheship') }}</div>
      <SpUploadGroup :business-id="shipInfo.id" file-type="ship/hold-hatch/design" accept="image" />
      <div class="mg-t-20 sp-color-11 text-left title-tip">{{ $l('Others') }}</div>
      <SpUploadGroup :business-id="shipInfo.id" file-type="ship/hold-hatch/other" accept="image" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard'
import SpInput from '@/components/common/SpInput'
import SpSelect from '@/components/common/SpSelect'
import ShipInfoTable from '@/components/shipOwner/tonnages/newTonnage/ShipInfoTable'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import { getShipStructureTypeApi, getShipCargoTypeApi, getShipHoldTypeApi, getShipDeckTypeApi } from '@/request/APIs/so'
import SpSelectOption from '@/components/common/SpSelectOption'
export default {
  name: 'ShipTypeHoldType',

  nameSpace: 'shipOwner.tonnages.newTonnage.ShipTypeHoldType',

  components: {
    SpSelectOption,
    SpCard,
    SpInput,
    SpSelect,
    SpUploadGroup,
    ShipInfoTable
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  emits: ['update:modelValue'],

  data () {
    return {
      shipStructureType: {},
      shipCargoType: {},
      shipHoldType: {},
      shipDeckType: {}
    }
  },

  computed: {
    shipInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    },

    shipStructureTypeOptions () {
      return this.shipStructureType[this.shipInfo.title.toLowerCase()]
    },

    shipCargoTypeOptions () {
      return this.shipCargoType[this.shipInfo.title.toLowerCase()]
    },

    shipHoldTypeOptions () {
      return this.shipHoldType[this.shipInfo.title.toLowerCase()]
    },

    shipDeckTypeOptions () {
      return this.shipDeckType[this.shipInfo.title.toLowerCase()]
    }
  },

  created () {
    this.getShipStructureType()
    this.getShipCargoType()
    this.getShipHoldType()
    this.getShipDeckType()
  },

  mounted () {
  },

  methods: {
    // 获取按结构划分的船舶类型选项
    getShipStructureType () {
      getShipStructureTypeApi().then(res => {
        this.shipStructureType = res.data
      })
    },

    // 获取按可装货类划分的船舶类型选项
    getShipCargoType () {
      getShipCargoTypeApi().then(res => {
        this.shipCargoType = res.data
      })
    },

    // 获取船舶舱型选项
    getShipHoldType () {
      getShipHoldTypeApi().then(res => {
        this.shipHoldType = res.data
      })
    },

    // 获取船舶舱内甲板层数选项
    getShipDeckType () {
      getShipDeckTypeApi().then(res => {
        this.shipDeckType = res.data
      })
    }
  }
}
</script>

<style scoped lang="less">
.ShipTypeHoldType{
  .card-content{
    padding: @gap;
  }
  .right-side{
    box-sizing:border-box;
    padding:@gap;
    .title{
      font-size: 18px;
      font-family: Arial;
      font-weight: 400;
    }
    .title-tip{
      font-size: 18px;
      font-family: Arial;
      font-weight: 400;
      opacity: 0.5;
    }
  }
  .outer-gap{
    margin-top: @gap*3;
  }
}
</style>
